import {
  displayErrorToast,
  displaySucessToast,
  displayWarningToast,
} from "@endya-conformite/ui-kit";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useCancelCQBatchMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: string[]) => ControleQuinquennalApi.cancelBatch(ids),
    onSuccess: ({ annules, echecs }) => {
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.all,
      });

      if (annules.length > 0) {
        displaySucessToast(
          annules.length === 1
            ? "1 contrôle quinquennal a été annulé."
            : `${annules.length} contrôles quinquennaux ont été annulés.`
        );
      }
      if (echecs.length > 0) {
        displayWarningToast(
          echecs.length === 1
            ? "1 contrôle quinquennal n'a pas pu être annulé."
            : `${echecs.length} contrôles quinquennaux n'ont pas pu être annulés.`
        );
      }
    },
    onError: (error) => {
      console.error("Error during CQ batch cancellation mutation", error);
      displayErrorToast(
        "Une erreur est survenue lors de l'annulation des contrôles quinquennaux."
      );
    },
  });
};
